import { HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { adminVoucherListHeader, adminVoucherListWidth } from 'constants/pagination';

import { AdminVoucherPaginationProps } from 'models/Admin/AdminVoucherPageTypes';
import AdminVoucherListPaginationTable from './AdminVoucherListPaginationTable';
import { getWidthRation } from 'utils/calculateWdith';
import { NothingDataInManagingPatientsPagination } from '../AddDiagnosisPage/NothingDataInPagination';
import CustomedPagination from 'components/Pagination/CustomedPagination';

const AdminVoucherListPagination = ({
    currentPage,
    totalPages,
    pageGroup,
    handlePageGroup,
    handlePageChange,
    currentData,
    initNumber,
    totalCount,
    handleResetButton,
    clickSmsSendButton,
}: AdminVoucherPaginationProps) => {
    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper>
                    {adminVoucherListHeader.map((name, idx) => {
                        return (
                            <TableCell key={idx} $width={getWidthRation(adminVoucherListWidth[idx])} $type='header' $justifyContent='space-between' cellType={name.type}>
                                {name.title}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {currentData?.length !== 0 ? (
                    <AdminVoucherListPaginationTable currentPage={currentPage} totalCount={totalCount} currentData={currentData} clickSmsSendButton={clickSmsSendButton} />
                ) : (
                    <NothingDataInManagingPatientsPagination initNumber={initNumber} handleResetButton={handleResetButton} />
                )}
            </TableLayout>
            {currentData && totalPages !== 0 && (
                <CustomedPagination currentPage={currentPage} onChangeCurrentPage={handlePageChange} onChangeSectionIdx={handlePageGroup} sectionIndex={pageGroup} totalPages={totalPages} />
            )}
        </Layout>
    );
};

export default AdminVoucherListPagination;
